import React, { Component } from 'react'
import Box from '@mui/material/Box';
import colors from './Colors';
import Plot from 'react-plotly.js';
import './Styles/NFP.css'
import { DataGrid } from '@mui/x-data-grid';
import CsvDownload from 'react-json-to-csv'
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Table from "./Containers/Table";
import SplashScreen from './SplashScreen.tsx';
import './Styles/tablesales.css'
// import CsvDownload from "react-json-to-csv";

const handleDownload = (data, name) => {
  const csvRows = data

  // Add headers to the CSV
  const headers = Object.keys(csvRows[0]);
  const csvContent = headers.join(',') + '\n';

  // Add data rows to the CSV
  const rowsContent = csvRows.map(row => Object.values(row).join(',')).join('\n');

  // Combine headers and data rows
  const csvString = csvContent + rowsContent;

  // Create a virtual link and set its attributes
  const link = document.createElement('a');
  link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvString);
  link.download = name;

  // Simulate a click event to trigger the download
  link.click();
};




export class Sales extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            email:[],
            active: false,
            addr:'',
            data:{
              count:0,
              sales:0,
            },
            sales:{
              x:[],
              y:[],
            },
            bundle:{
              x:[],
              y:[],
            },
            trans:{
                row:[{}],
                column:[],
                transactions:0,
                mimShareAmount:0,
                paymentInit:0,
            },
            searchValue: '',
            searchdata:[],
            lock:false,
            done: [],
            id: sessionStorage.getItem('id') || '',
            secret: sessionStorage.getItem('authkey') || '',
            level: sessionStorage.getItem("level"),
            selectedrequests:[],
            totalamount:0,
            payi:true,
            payc:true,
            ins:"",
            re:"",
            payable:0,
            isFlipped:false,
            loadingii:false,
            tabledata:[{}],
            tabname:"",
        };
      }
    
  handlenoTransactions (){
    var i = prompt('Input number of Transaction Amount you want? For Example 1 will give you all impactors with only 1 transaction made since Verification day.')
    var addrr = "http://sfoadmin.myimpactmeter.com:5050/";
    if(i===null){
      return
    }
    fetch(addrr +"sales/tranamount?day="+i)
      .then((response) => response.json())
      .then((data) => {
        this.setState({tabledata:data['data']})
        this.setState({tabname:'Transaction with ' + i + '.csv'})
        var email = []
        for (let index = 0; index < data['data'].length; index++) {
          email.push(data['data'][index]['email'])
        
        }
        this.setState({email:email})
        // handleDownload(data['data'],'Transaction with ' + i + '.csv');
      });
  }

      
  handlenoAging (){
    var i = prompt('Input number of Aging Amount you want? For Example 10 will give you all impactors with last transaction 10 day or greater from today.')
    if(i===null){
      return
    }
    var addrr = "http://sfoadmin.myimpactmeter.com:5050/";
    fetch(addrr +"/sales/aging?day="+i)
      .then((response) => response.json())
      .then((data) => {
        this.setState({tabledata:data['data']})
        this.setState({tabname:'Aging with ' + i + '.csv'})
        var email = []
        for (let index = 0; index < data['data'].length; index++) {
          email.push(data['data'][index]['email'])
        
        }
        this.setState({email:email})
        // handleDownload(data['data'],'Aging with ' + i + '.csv');
      });
  }


  handlenonVer (){
    var addrr = "http://sfoadmin.myimpactmeter.com:5050/";
    fetch(addrr +"/sales/nonVer")
      .then((response) => response.json())
      .then((data) => {
        this.setState({tabledata:data['data']})
        this.setState({tabname:'Unverifed.csv'})
        var email = []
        for (let index = 0; index < data['data'].length; index++) {
          email.push(data['data'][index]['email'])
        
        }
        this.setState({email:email})
        // handleDownload(data['data'],'Unverifed.csv');
      });
  }

  handletkr (){
    var i = prompt('Enter Email')
    if(i===null){
      return
    }
    var addrr = "http://sfoadmin.myimpactmeter.com:5050/";
    fetch(addrr +"/sales/tkr?email="+i)
      .then((response) => response.json())
      .then((data) => {
        alert(data['message'])
      });
  }


       
  render() {
    return (
      <div className="allcontents">
            <div style={{'display':"flex"}}>
                <div>
                    <div className="edubutt" onClick={()=>{
                      this.handlenoTransactions();
                    }} >No of Transactions of Impactors</div> 
                    <br></br>
                    <div className="edubutt" onClick={()=>{
                      this.handlenoAging();
                    }} >Aging Impactors</div>
                    <br></br>
                    <div className="edubutt" onClick={()=>{
                      this.handlenonVer();
                    }} >Non Verified</div>
                    <br></br>
                    <div className="edubutt" onClick={()=>{
                      this.handletkr();
                    }} >Token Generate Impactor</div>
                    <br></br>
                </div>
                {   this.state.tabledata.length !== 1?
                    <div className='tablesales'>
                        <Table data={this.state.tabledata} />
                        <div style={{'display':"flex"}}>
                            <div className='downloadbutton' onClick={()=>{
                              handleDownload(this.state.tabledata,this.state.tabname);
                            }}>
                              Download
                            </div>
                            <div >
                              
                              <a className='mailbutton' href={`mailto:${''}${''}${this.state.email}`}> Mail </a>
                            </div>  
                        </div>
                    </div> : <div></div>
                }
            </div>
           
      </div>
    )
  }
}

export default Sales